import { select, put } from 'redux-saga/effects';
import { groupBy, map, filter } from 'underscore';

import { ReturnsMapStore, ReturnMapTreeNode } from '../model/redux-model';
import { SET_TREE_ROOT } from '../model/redux-actions';

export function* recalculateSaga() {
	const store: ReturnsMapStore = yield select();

	const colorValueGetter = store.dataSources.colors.valueProviderByKey[store.settings.color];

	const level1Strategy = store.dataSources.groups.attributeProdivderByKey[store.settings.groupLevel1];
	const level2Strategy = store.dataSources.groups.attributeProdivderByKey[store.settings.groupLevel2];

	const filteredEtfs =
		store.settings.tradeStatus == ''
			? store.etfs.all
			: store.etfs.all.filter(x => x.tradeStatus?.name == store.settings.tradeStatus);

	const root: ReturnMapTreeNode = {
		name: 'Карта ETF',
		children: map(
			groupBy(filteredEtfs, etf => level1Strategy(etf)),
			(etfBylevel1, level1) => {
				return {
					name: level1,
					children: map(
						groupBy(etfBylevel1, etf => level2Strategy(etf)),
						(etfByLevel2, level2) => {
							const children = map(etfByLevel2, etf => {
								return {
									name: etf.ticker,
									href: `https://rusetfs.com/etf/${etf.isin}`,
									assetsUnderManagement: etf.assetsUnderManagementByCurrency[store.settings.currency],
									colorValue: colorValueGetter(etf.fieldValuesByCurrency[store.settings.currency])
								};
							});
							const childrenWithColorValue = map(
								filter(children, x => x.colorValue != null),
								x => ({ name: x.name, href: x.href, assetsUnderManagement: x.assetsUnderManagement, colorValue: x.colorValue! }));

							return {
								name: level2,
								children: childrenWithColorValue
							};
						}
					)
				};
			})
		};

	yield put(SET_TREE_ROOT(root));
}